import './App.css'
import React from 'react'
import prophoto from './files/pro1.jpeg'
import cv from './files/CV.pdf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import { faFile, faEnvelope, faHouse } from '@fortawesome/free-solid-svg-icons'
import HomePage from './HomePage.js'
import { useState } from 'react'
function App () {
  const [portfolioVisible, setPortfolioVisible] = useState(true)

  const handleHouseClick = () => {
    setPortfolioVisible(true)
  }
  const handleHidePortfolio = () => {
    setPortfolioVisible(false)
  }
  return (
    <div className="App">
      {portfolioVisible ? (
        <HomePage onPortfolioHide={handleHidePortfolio} />
      ) : (
        <div className="card_widget">
          <div className="App-header">
            <header className='header'>
              <div className='name_container'>
                <p id='name'>
                  <a onClick={handleHouseClick} id='name'>
                    YINUO YANG
                  </a>
                  {/* <p id='c_name'>杨依诺</p> */}
                </p>
              </div>
            </header>

            {//<span className='about_title'> About </span> 
            }

            <div className='about_content'>
              <p id='bio'>
                Hi! I am Yinuo, an undergraduate student at
                <a href='https://umich.edu/' target='_blanket'> University of Michigan, Ann Arbor,</a>&nbsp;
                majoring in Computer Science and Data Science.
                My research interest lies in Human Computer Interaction.
                I am currently working with <a href='https://from.so/Steve_Oney/' target='_blanket'>Prof. Steve Oney</a>.
                Previously, I worked with <a href='https://aprilwang.me/' target='_blanket'>Dr. April Yi Wang</a>&nbsp;
                (now in ETH Zürich), and I am grateful for her guidance,
                especially during a time when I do not have much prior experience. See my page
                <a href='#' onClick={handleHouseClick}> Here</a>.
              </p>
              <img id='photo' src={prophoto} alt='photo' />
            </div>
            <div className="custom-social-links">
              <a href='#' onClick={handleHouseClick} className="custom-social-link" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faHouse} />
              </a>
              <a href={cv} className="custom-social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFile} />
              </a>
              <a href="https://github.com/inonnno" className="custom-social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href={`mailto:${'inon@umich.edu'}`} className="custom-social-link" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </div>
          </div >
        </div >
      )
      }
      <div className='root' >
        <p>@Yinuo - yinooyang [at] nd [dot] edu</p>
      </div>

    </div >
  )
}

export default App
